<template>
  <div>
    <div class="testimonials testimonials-background">
      <img src="@/assets/images/quote.png" />
      <p>
        “What the GC-MS profile of an essential oil means to a modern scientist, Dropsmart means to aromatherapy. Or simply put, I see
        Dropsmart as a powerful tool to strengthen the evidence-based perspective of aromatherapy in terms of its therapeutic value. In
        addition to its scientific-medicinal context, it should become the leading global platform for essential oil producers.”
      </p>
      <p class="testimonials-box nomargin">
        <img src="@/assets/images/dropsmith-kocevar-glavac.png" />
        <span class="testimonials-info">
          <span class="testimonials-name">Prof. Dr. Nina Kočevar Glavač</span>
          Professor at Faculty of Pharmacy, researcher at the Department of Pharmaceutical Biology and chief editor of 'Modern Cosmetics'
        </span>
      </p>
    </div>
    <div class="testimonials testimonials-background">
      <img src="@/assets/images/quote.png" />
      <p>
        Dropsmart has exceeded all my expectations. I can save my blends, I can share with the community and I have links to research and
        evidence which makes it an important tool for me in my clinical practice. It is also helping me to prepare for my aromatherapy
        chemistry classes and my students are also finding it as an invaluable tool.
      </p>
      <p class="testimonials-box nomargin">
        <img src="@/assets/images/testimonials-photo.png" />
        <span class="testimonials-info">
          <span class="testimonials-name">Marika Fleri</span>
          National Cancer Plataform Association coordination, Clinical Aromatherapist and Educator
        </span>
      </p>
    </div>
    <div class="testimonials testimonials-background">
      <img src="@/assets/images/quote.png" />
      <p>
        “Dropsmart is one of my favourite databases for my Essential oil blend workshops, product creations and treatments. You can see what
        you create, and to what effect the combined oils have. In addition, what cautions the oils have on the page including evidence and
        research data. I find Dropsmart is a very useful tool and aid for people who want to use essential oils safely, being more effective
        in their work.”
      </p>
      <p class="testimonials-box nomargin">
        <img src="@/assets/images/dropsmith-rieko-oshima-barclay.png" />
        <span class="testimonials-info">
          <span class="testimonials-name">Rieko OSHIMA-BARCLAY</span>
          Western Medical Herbalist, Aromatherapist, Herbal and Aromatic products creator and teacher
        </span>
      </p>
    </div>
    <h2 class="textMoneyback" v-if="this.routeName != 'GiftCard'">
      You can cancel at any time.
      <br />No hard feelings.
    </h2>
    <p class="text-riskFree" v-if="this.routeName != 'GiftCard'">
      You can cancel your account at any time. If you see that
      <br />Dropsmart is not for you, you can simply cancel it.
    </p>
  </div>
</template>

<style lang="scss">
.textMoneyback {
  color: #434343;
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 19px;
  margin-top: 50px;
}

.text-riskFree {
  font-size: 18px;
  color: #434343;
  margin-bottom: 70px;
}

.testimonials {
  background: #f7f7f7;
  margin-bottom: 20px;
  padding: 40px 45px;
  img {
    margin-bottom: 25px;
    max-width: 80px;
  }
  p {
    color: #545454;
    font-size: 20px;
    line-height: 30px;
    img {
      margin: 0;
    }
  }
  .nomargin {
    margin: 0;
  }
  .testimonials-box {
    display: flex;
    align-items: center;
    img {
      align-self: center;
      margin-right: 30px;
    }
  }
  .testimonials-info {
    color: #545454;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    max-width: 300px;
    .testimonials-name {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 5px;
    }
  }
}
</style>

<script>
export default {
  name: "StandardLeft",
  props: ['routeName'],
}
</script>
